import React from 'react';
import { withRouter } from 'react-router';
import useSWR from 'swr';
import Img from '../../../assets/images/cake2.png';

import './birthday.styles.scss';

const BirthdayCelebrants = (props) => {
  const { data, error, isLoading } = useSWR(
    'BirthdayCelebrants/today/students',
  );

  const recordsCount = data?.pagingInfo?.recordsCount || 0;

  if (isLoading || error || recordsCount === 0) {
    return <div className="birthday" />;
  }

  return (
    <div className="birthday">
      <div onClick={() => props.history.push('/birthdays')}>
        <img src={Img} alt="" />
      </div>
    </div>
  );
};

export default withRouter(BirthdayCelebrants);
